import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { pagination, errorMsg, spinner, newIndicator } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { DOMAttr, DangerousHtml, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Http_imageUrl } from "./State.fs.js";
import * as react from "react";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { toString } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { Page } from "./Types.fs.js";
import { equals } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { map, toArray, singleton as singleton_1, ofArray, empty as empty_1 } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Option, columns } from "../../../fable_modules/Fulma.3.0.0/Layouts/Columns.fs.js";
import { Option as Option_1, ISize, column } from "../../../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Screen } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { bfsCard } from "../Shared/Card.fs.js";
import { toString as toString_1 } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";

export function newsListItemView(news, navigateTo) {
    const children_22 = toList(delay(() => append(news.IsNew ? singleton(newIndicator) : empty(), delay(() => {
        let children;
        return append(singleton((children = toList(delay(() => {
            let props;
            return news.HasImage ? singleton((props = [new HTMLAttr(65, ["image"]), new HTMLAttr(149, [Http_imageUrl(news.Id)])], react.createElement("img", keyValueList(props, 1)))) : empty();
        })), react.createElement("span", {
            className: "image is-hidden-mobile",
        }, ...children))), delay(() => {
            let children_10, children_6, children_4;
            return append(singleton((children_10 = [(children_6 = [(children_4 = [react.createElement("a", {}, news.Titel)], react.createElement("span", {
                className: "product-name",
            }, ...children_4))], react.createElement("a", {}, ...children_6)), react.createElement("span", {
                className: "product-description",
            }, news.Textanfang)], react.createElement("span", {
                className: "product-info",
            }, ...children_10))), delay(() => {
                let children_20, children_12, arg, children_18, children_16;
                return singleton((children_20 = [(children_12 = [(arg = toString(news.Datum, "dd.MM.yyyy"), toText(printf("%s"))(arg))], react.createElement("span", {
                    className: "date",
                }, ...children_12)), (children_18 = [(children_16 = ["Weiterlesen", react.createElement("i", {
                    className: "fas fa-angle-right fa-lg",
                })], react.createElement("a", {}, ...children_16))], react.createElement("span", {
                    className: "view-more",
                }, ...children_18))], react.createElement("span", {
                    className: "product-abstract is-hidden-mobile",
                }, ...children_20)));
            }));
        }));
    }))));
    return react.createElement("li", {
        className: "flat-card is-auto is-list-item",
        onClick: (_arg) => {
            navigateTo(new Page(1, [news.Id]));
        },
    }, ...children_22);
}

export function newsListView(newsList, navigateTo, withPagination) {
    switch (newsList.tag) {
        case 1:
            return spinner;
        case 2:
            return errorMsg("Fehler beim Laden der News!");
        case 3:
            if (equals(newsList.fields[0].Items, empty_1())) {
                return react.createElement("div", {}, "Keine News Vorhanden");
            }
            else {
                return Array.from(delay(() => {
                    let children_4;
                    return append(singleton(columns(ofArray([new Option(8, ["is-product-list newslist"]), new Option(2, [])]), singleton_1(column(singleton_1(new Option_1(0, [new Screen(0, []), new ISize(16, [])])), singleton_1((children_4 = [toArray(map((i) => newsListItemView(i, navigateTo), newsList.fields[0].Items))], react.createElement("ul", {}, ...children_4))))))), delay(() => (withPagination ? singleton(pagination(newsList.fields[0], (page) => {
                        navigateTo(new Page(0, [page]));
                    })) : empty())));
                }));
            }
        default:
            return react.createElement("div", {});
    }
}

export function newsItemDetails(id, backToPage, news, navigateTo) {
    let children_2, children_12;
    return [columns(ofArray([new Option(8, ["is-product-list newsarticle"]), new Option(2, [])]), singleton_1(column(singleton_1(new Option_1(0, [new Screen(0, []), new ISize(16, [])])), singleton_1(bfsCard(singleton_1((children_2 = [react.createElement("i", {
        className: "fas fa-angle-left",
    }), "Zurück zur Übersicht"], react.createElement("a", {
        onClick: (_arg) => {
            navigateTo(new Page(0, [backToPage]));
        },
    }, ...children_2))), singleton_1((children_12 = toList(delay(() => {
        let children_6, children_4, props_4, copyOfStruct;
        return append(news.HasImage ? singleton((children_6 = [(children_4 = [(props_4 = [new HTMLAttr(65, ["news-image"]), new HTMLAttr(149, [Http_imageUrl((copyOfStruct = id, toString_1(copyOfStruct)))])], react.createElement("img", keyValueList(props_4, 1)))], react.createElement("div", {}, ...children_4))], react.createElement("div", {
            className: "column is-4",
        }, ...children_6))) : empty(), delay(() => {
            let children_10, props_10;
            return singleton((children_10 = [(props_10 = [new HTMLAttr(65, ["content"]), new DOMAttr(0, [new DangerousHtml(news.Html)])], react.createElement("div", keyValueList(props_10, 1)))], react.createElement("div", {
                className: "column",
            }, ...children_10)));
        }));
    })), react.createElement("div", {
        className: "columns",
    }, ...children_12))))))))];
}

export function newsItemView(id, backToPage, news, navigateTo) {
    switch (news.tag) {
        case 1:
            return spinner;
        case 2:
            return errorMsg("Fehler beim Laden der News!");
        case 3:
            return newsItemDetails(id, backToPage, news.fields[0], navigateTo);
        default:
            return react.createElement("div", {});
    }
}

export function view(model, dispatch, navigateTo) {
    if (model.tag === 1) {
        const m_1 = model.fields[0];
        return newsItemView(m_1.Id, m_1.BackToPage, m_1.NewsItem, (arg_1) => {
            navigateTo(arg_1);
        });
    }
    else {
        return newsListView(model.fields[0].NewsList, (arg) => {
            navigateTo(arg);
        }, true);
    }
}

//# sourceMappingURL=View.fs.js.map
